import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import './MentionsLegales.css';
import imageMention from '../images/imagemention.png';

const MentionsLegales = () => {
  return (
    <>
      <SEOHead
        title="Mentions Légales - Mon Dépannage Informatique"
        description="Mentions légales du site mon-depannage-informatique.fr. Informations sur l'hébergeur, propriété intellectuelle et conditions d'utilisation."
        canonical="https://mon-depannage-informatique.fr/mentions-legales"
        keywords="mentions légales, informations légales, hébergeur, propriété intellectuelle"
      />

      <div className="mentions-legales-page">
        <div className="container">
          <div className="mentions-header">
            <h1>Mentions Légales</h1>
            <p>Informations légales concernant le site mon-depannage-informatique.fr</p>
          </div>

          <div className="mentions-content">

            <section className="mentions-section">
              <h2>Identification du site</h2>
              <div className="info-block">
                <p><strong>Nom du site :</strong> mon-depannage-informatique.fr</p>
                <p><strong>URL :</strong> <a href="https://mon-depannage-informatique.fr/" target="_blank" rel="noopener noreferrer">https://mon-depannage-informatique.fr/</a></p>
              </div>
            </section>

            <section className="mentions-section">
              <h2>Informations complémentaires</h2>
              <div className="image-container">
                <img src={imageMention} alt="Informations légales complémentaires" className="mention-image" />
              </div>
            </section>

            <section className="mentions-section">
              <h2>Nous contacter</h2>
              <p>Pour toute question ou demande d'information, vous pouvez nous joindre via notre formulaire de contact :</p>
              <Link to="/contact" className="contact-link">
                Accéder au formulaire de contact
              </Link>
            </section>

            <section className="mentions-section">
              <h2>Hébergement</h2>
              <div className="info-block">
                <p><strong>Hébergeur :</strong> O2SWITCH</p>
                <p><strong>Adresse :</strong> 222-224 Boulevard Gustave Flaubert, 63000 Clermont-Ferrand</p>
                <p><strong>Forme juridique :</strong> SARL o2switch au capital de 7500€</p>
                <p><strong>RCS :</strong> Clermont-Ferrand</p>
                <p><strong>SIRET :</strong> 510 909 80700016</p>
                <p><strong>TVA :</strong> FR35510909807</p>
                <p><strong>Marque :</strong> La marque o2switch est déposée INPI sous le numéro 09 3 645 729</p>
                <p><strong>Site web :</strong> <a href="http://www.o2switch.fr/" target="_blank" rel="noopener noreferrer">www.o2switch.fr</a></p>
              </div>
            </section>

            <section className="mentions-section">
              <h2>Conditions générales d'utilisation</h2>
              <p>
                En accédant et en utilisant ce site web, vous acceptez sans réserve les présentes conditions générales d'utilisation.
                Ces conditions peuvent être modifiées ou complétées à tout moment. Il est donc recommandé de les consulter régulièrement.
              </p>
            </section>

            <section className="mentions-section">
              <h2>Nature des informations</h2>
              <p>
                Les contenus et informations disponibles sur ce site sont fournis à titre informatif uniquement.
                Ils ne revêtent aucun caractère exhaustif et ne sauraient engager la responsabilité du propriétaire du site.
              </p>
              <p>
                Le propriétaire du site décline toute responsabilité en cas de dommages, directs ou indirects,
                résultant de l'utilisation du site ou de l'impossibilité d'y accéder.
              </p>
            </section>

            <section className="mentions-section">
              <h2>Contenu généré par les utilisateurs</h2>
              <p>
                Les visiteurs du site peuvent être amenés à publier du contenu dans les espaces dédiés,
                notamment via les commentaires. Chaque utilisateur demeure pleinement responsable du contenu qu'il publie,
                tant sur le plan juridique que déontologique.
              </p>
              <p>
                Le propriétaire du site se réserve le droit de supprimer, sans notification préalable,
                tout contenu publié par un utilisateur qui contreviendrait à la législation en vigueur ou
                aux règles de bonne conduite du site.
              </p>
            </section>

            <section className="mentions-section">
              <h2>Droits de propriété intellectuelle</h2>
              <p>
                Sauf indication contraire explicite, l'ensemble des contenus présents sur ce site
                (textes, images, graphismes, logos, icônes, sons, logiciels, etc.) demeure la propriété exclusive
                de leurs auteurs respectifs en matière de droits de propriété intellectuelle et d'usage.
              </p>
              <p>
                Toute reproduction, représentation, modification, publication ou adaptation, totale ou partielle,
                des éléments du site, quel que soit le procédé ou le support utilisé, est strictement interdite
                sans l'autorisation écrite préalable de l'auteur.
              </p>
              <p>
                Toute utilisation non autorisée du site ou de ses éléments constitue une contrefaçon
                susceptible d'engager la responsabilité civile et pénale du contrefacteur.
              </p>
              <p>
                Les marques et logos présents sur le site sont la propriété de leurs détenteurs respectifs.
              </p>
            </section>

            <section className="mentions-section">
              <h2>Liens hypertextes</h2>

              <h3>Liens sortants</h3>
              <p>
                Le propriétaire du site ne peut être tenu responsable du contenu des sites externes
                référencés via des liens hypertextes, ni de leur disponibilité ou de leur pertinence.
              </p>

              <h3>Liens entrants</h3>
              <p>
                Les liens hypertextes pointant vers ce site sont autorisés sous réserve que :
              </p>
              <ul>
                <li>Ils s'ouvrent dans une nouvelle fenêtre</li>
                <li>Ils sont présentés de façon claire et non équivoque</li>
                <li>Ils ne créent aucun risque de confusion avec le site source</li>
                <li>Ils ne présentent pas le contenu de manière trompeuse ou contraire à la législation</li>
              </ul>
              <p>
                Le propriétaire du site se réserve le droit d'exiger le retrait d'un lien
                si le site source ne respecte pas ces conditions.
              </p>
            </section>

            <section className="mentions-section">
              <h2>Protection des données personnelles</h2>
              <p>
                Conformément à la réglementation en vigueur, tout utilisateur dispose d'un droit d'accès,
                de rectification et d'opposition concernant ses données personnelles.
                Pour exercer ces droits, il convient d'adresser une demande écrite et signée,
                accompagnée d'une pièce d'identité.
              </p>
              <p>
                Ce site ne collecte pas d'informations personnelles de manière systématique
                et n'est pas soumis à déclaration auprès de la CNIL.
              </p>
            </section>

          </div>
        </div>
      </div>
    </>
  );
};

export default MentionsLegales;
